import Modal from 'components/Modal/Modal';
import SalonContact from 'components/SalonContact/SalonContact';

import { useBusiness } from 'hooks/business/useBusiness';
import { useAppContext } from 'hooks/context/useAppContext';
import { usePreferences } from 'hooks/preferences/usePreferences';

import s from './OfflineBookingModal.module.css';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const OfflineBookingModal = ({ isOpen, onClose }: TProps) => {
  const { email, phone, cellPhone } = useBusiness();
  const { promptForContactOnBooking } = usePreferences();
  const { publicUser } = useAppContext();
  const { multi_user: isMultiUser } = publicUser;

  return isOpen ? (
    <Modal className={s.modal} onClose={onClose} title="Please Contact">
      {promptForContactOnBooking ? (
        <>
          <div>To schedule a booking please contact</div>
          <SalonContact
            businessEmail={email}
            businessPhone={phone}
            cellPhone={cellPhone}
          />
          <div>
            with your name, {isMultiUser && <>your provider&apos;s name, </>}
            service requested and the desired date/time of your booking.
          </div>
        </>
      ) : (
        <div>
          The professional you are requesting is not accepting online bookings
          at this time.
        </div>
      )}
    </Modal>
  ) : null;
};
